$window = $(window);

$slick_slider_1 = $('body.template-collection .logo-slider__inner');

settings_1 = {
        infinite: true,
        dots : true,
        arrows : false,
        slidesToShow: 12,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    };

$slick_slider_1.slick(settings_1);

$window.on('resize', function() {
    if ($window.width() < 768) {
        if ($slick_slider_1.hasClass('slick-initialized'))
            $slick_slider_1.slick('unslick');
        return
    }
    if ( ! $slick_slider_1.hasClass('slick-initialized'))
        return $slick_slider_1.slick(settings);
});



$slick_slider = $('body.template-index .logo-slider__inner');


    settings =  {
        infinite: true,
        dots : true,
        arrows : true,
        slidesToShow: 8,
        slidesToScroll: 1,
       prevArrow: '<div class="slick-prev"></div>',
       nextArrow: '<div class="slick-next"></div>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    };


$slick_slider.slick(settings);

$window.on('resize', function() {
    if ($window.width() < 768) {
        if ($slick_slider.hasClass('slick-initialized'))
            $slick_slider.slick('unslick');
        return
    }
    if ( ! $slick_slider.hasClass('slick-initialized'))
        return $slick_slider.slick(settings);
});